import _ from 'lodash';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//- material
import ShieldIcon from '@material-ui/icons/VerifiedUser';
import { withStyles } from '@material-ui/core/styles';

import DriverReportContainer from '../../containers/Driver/DriverReport';
import sphereLogo from '../../images/logos/sphere_blueText.svg';
import { infoByReportType } from '../../libs/reportInfo';

import CheckboxCheckedIcon from '@material-ui/icons/CheckBox';
import CheckboxEmptyIcon from '@material-ui/icons/CheckBoxOutlineBlank';

//import WarningIcon from "@material-ui/icons/Warning";

const styles = () => {
	//const fw = 1280;
	//const fh = 1664;

	const iw = 1088;
	const ih = 1472;

	const p = (v) => {
		return `${v * 100}%`;
	};
	const pw = (v) => {
		return `${(v / iw) * 100}%`;
	};
	const ph = (v) => {
		return `${(v / ih) * 100}%`;
	};

	const lineColor = '#ccc';
	return {
		root: {
			//position : 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
			padding: `${p(0.07)} ${p(0.095)} 0 ${p(0.095)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			fontSize: '1.8vw',
		},
		aspectRatio: {
			position: 'fixed',
			width: '100%',
			paddingBottom: '129.411%',
			//background: 'gold',
			top: 0,
			left: 0,
		},
		pageBackground: {
			position: 'fixed',
			width: '100%',
			height: '100%',
			background: 'white',
			top: 0,
			left: 0,
		},
		inner: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},
		logoContainer: {
			textAlign: 'right',
		},
		logo: {
			width: pw(210),
			//height: p(0.),
		},
		title: {
			textTransform: 'uppercase',
			letterSpace: 1,
			fontSize: '200%',
			textAlign: 'center',
			marginBottom: ph(60),
			marginTop: ph(20),
		},
		rowContainer: {
			display: 'flex',
			flexDirection: 'row',
		},
		itemContainer: {
			display: 'flex',
			flexDirection: 'row',
			flexGrow: 1,
			marginBottom: ph(42),
			marginRight: pw(10),
			alignItems: 'flex-end',
		},
		itemLabel: {
			color: '#333',
			fontWeight: 500,
			textTransform: 'uppercase',
			marginRight: pw(2),
			//whiteSpace : 'nowrap',
			//marginRight :
		},
		checkItem: {
			//flexGrow : 1,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
		},
		itemValue: {
			color: '#555',
			textAlign: 'left',
			paddingLeft: pw(25),
			borderBottom: `1px solid ${lineColor}`,
			flexGrow: 1,
			whiteSpace: 'nowrap',
		},
		multiLineItemContainer: {
			display: 'flex',
			flexDirection: 'column',
			flexGrow: 1,
			marginBottom: ph(40),
			marginRight: pw(10),
			overflow: 'hidden',
		},
		multiLineItemValue: {
			marginTop: pw(10),
			padding: pw(13),
			border: `1px solid ${lineColor}`,
			color: '#555',
			overflow: 'none',
			fontSize: '90%',
		},
		signatureContainer: {
			display: 'flex',
			flexDirection: 'row',
			flexGrow: 1,
			marginBottom: ph(35),
			marginRight: pw(10),
			marginTop: ph(35),
			alignItems: 'center',
		},
		shieldIcon: {
			width: pw(50),
			height: 'auto',
		},
		checkboxIcon: {
			width: pw(40),
			height: 'auto',
			marginLeft: pw(20),
			marginRight: pw(5),
		},
		vehicleTitle: {
			textAlign: 'center',
			border: '1px solid #aaa',
			padding: pw(5),
			fontWeight: 500,
			marginTop: pw(10),
			marginBottom: pw(15),
			textTransform: 'uppercase',
			flexGrow: 1,
		},
		mixContainer: {
			width: '100%',
		},
		mixTitle: {
			textAlign: 'center',
			padding: pw(5),
			fontWeight: 500,
			marginTop: pw(10),
			marginBottom: pw(15),
			textTransform: 'uppercase',
			flexGrow: 1,
			fontSize: '200%',
		},
		accidentDrawing: {
			width: '100%',
		},
	};
};

class DriverReport extends Component {
	constructor(props) {
		super(props);
		const driverReportId = _.get(this.props, ['match', 'params', 'driverReportId']);
		const accessToken = _.get(this.props, ['match', 'params', 'accessToken']);
		//const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			driverReportId: driverReportId ? parseInt(driverReportId, 10) : undefined,
			accessToken,
			//securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { getDriverReport, driverReport } = this.props;
		const { driverReportId, accessToken } = this.state;
		if (driverReport) {
			return;
		}

		const params = {
			driverReportIds: [driverReportId],
		};

		if (accessToken) {
			params.accessToken = accessToken;
		}

		getDriverReport({
			params,
		});
	}

	renderChecked = (val) => {
		const { classes } = this.props;

		if (val) {
			return <CheckboxCheckedIcon className={classes.checkboxIcon} />;
		} else {
			return <CheckboxEmptyIcon className={classes.checkboxIcon} />;
		}
	};

	render() {
		const { classes, driverReport, userMap, resourceMap } = this.props;

		if (!driverReport) {
			return <div>Fetching delivery ticket..</div>;
		}

		/** @namespace driverReport.reportedToSupervisor **/
		/** @namespace driverReport.reportedToDispatch **/

		const { reportType, driverUserId } = driverReport;

		const user = userMap[driverUserId];
		if (!user) {
			return <div>Driver ({driverUserId}) not found.</div>;
		}

		const driverName = user.firstName + ' ' + user.lastName;

		const { title, printFields } = infoByReportType[reportType];

		return (
			<div className={classes.root}>
				<div className={classes.pageBackground} />
				<div className={classes.aspectRatio} />
				<div className={classes.inner}>
					<div className={classes.logoContainer}>
						<img alt="Logo" className={classes.logo} src={sphereLogo} />
					</div>

					<div className={classes.title}>{title}</div>

					{printFields.map((items, i) => {
						if (_.isObject(items)) {
							if (items.isPageBreak) {
								return <div key={`pageBreak${i}`} className="pageBreak" />;
							} else if (items.section) {
								return (
									<div className={classes.vehicleTitle} key={items.section}>
										{items.section}
									</div>
								);
							}
						}

						return (
							<div className={classes.rowContainer} key={i}>
								{items.map((item) => {
									const { path, label, basis, type, special, height } = item;

									const style = {};
									if (basis) {
										style.flexBasis = `${basis}%`;
									}

									let value = driverReport[path];

									if (type === 'boolean') {
										value = driverReport[path];
									} else if (type === 'date' || type === 'dateYearPicker') {
										value = moment(value).format('M/D/YY');
									} else if (type === 'time') {
										value = moment(value).tz('America/Los_Angeles').format('h:mm a (PT)');
									} else if (type === 'enum') {
										const option = _.find(item.options, { value });
										if (option) {
											value = option.display;
										}
									}

									if (path === 'driverName') {
										value = driverName;
									}

									if (path === 'socialSecurityNumber' && _.isString(value)) {
										value = value.replace(/[^-](?=.{2,}$)/g, '#');
									}

									if (type === 'multilineString') {
										let style = { height: '10vw' };
										if (height) {
											style = { height: `${height}vw` };
										}

										return (
											<div className={classes.multiLineItemContainer} key={path}>
												<div className={classes.itemLabel}>{label}</div>
												<div className={classes.multiLineItemValue} style={style}>
													{value}
												</div>
											</div>
										);
									} else if (special === 'reportedTo') {
										return (
											<div className={classes.itemContainer} key={special}>
												<div className={classes.checkItem}>
													<div className={classes.itemLabel}>Reported to</div>
												</div>
												<div className={classes.checkItem}>
													{this.renderChecked(driverReport.reportedToSupervisor)}
													<div className={classes.itemLabel}>Supervisor</div>
													<div className={classes.itemValue}>
														{driverReport.reportedToSupervisor}
													</div>

													{this.renderChecked(driverReport.reportedToDispatch)}
													<div className={classes.itemLabel}>Dispatch</div>
													<div className={classes.itemValue}>{driverReport.reportedToDispatch}</div>
												</div>
											</div>
										);
									} else if (special === 'driverSignature') {
										const { driverSignature, signatureDate } = driverReport;
										const signatureDateFormatted = moment(signatureDate).format('MMM Do, YYYY');
										return (
											<div className={classes.signatureContainer} key={special}>
												<ShieldIcon className={classes.shieldIcon} />
												<div>
													Driver electronically signed document with name {driverSignature} on{' '}
													{signatureDateFormatted}.
												</div>
											</div>
										);
									} else if (special === 'vehicle1') {
										return (
											<div className={classes.vehicleTitle} key={special}>
												Other Vehicle #1
											</div>
										);
									} else if (special === 'vehicle2') {
										return (
											<div className={classes.vehicleTitle} key={special}>
												Other Vehicle #2
											</div>
										);
									} else if (special === 'mixTitle') {
										return (
											<div className={classes.mixContainer} key={special}>
												<div className={classes.logoContainer}>
													<img alt="Logo" className={classes.logo} src={sphereLogo} />
												</div>
												<div className={classes.mixTitle}>
													Mix Investigation
													<br />
													Driver Questionnaire
												</div>
											</div>
										);
									} else if (special === 'company') {
										return (
											<div className={classes.itemContainer} style={style} key={special}>
												<div className={classes.itemLabel}>Company</div>
												<div className={classes.itemValue}>Superior Tank Lines</div>
											</div>
										);
									} else if (special === 'accidentDrawing') {
										/** @namespace driverReport.accidentDrawingResourceId **/
										const resource = resourceMap[driverReport.accidentDrawingResourceId];
										if (resource) {
											const { url } = resource;
											return (
												<div className={classes.vehicleTitle} key={special}>
													<img
														alt="Drawing of accident"
														src={url}
														className={classes.accidentDrawing}
													/>
												</div>
											);
										} else {
											return (
												<div className={classes.vehicleTitle} key={special}>
													missing drawing of accident
												</div>
											);
										}
									} else {
										return (
											<div className={classes.itemContainer} style={style} key={path}>
												<div className={classes.itemLabel}>{label}</div>
												<div className={classes.itemValue}>{value}</div>
											</div>
										);
									}
								})}
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

DriverReport.propTypes = {
	classes: PropTypes.object.isRequired,
	//publicGetDriverReport : PropTypes.func,
	getDriverReport: PropTypes.func.isRequired,
	driverReport: PropTypes.object,
	userMap: PropTypes.object,
	resourceMap: PropTypes.object,
};

export default _.flow([withStyles(styles), DriverReportContainer])(DriverReport);
